import { EMAIL_SPLIT_MODE } from 'utils/constants'

export const fromTemplates = templates =>
  templates.map(template => ({
    value: template.id,
    label: template.name
  }))

export const toContactsData = contacts => {
  return contacts.map(contact => {
    const dealsToFollowup = contact.dealsToFollowup.map(deal => ({ ...deal, isChecked: true }))
    const otherDealsToFollowUp = contact.otherDealsToFollowUp.map(deal => ({
      ...deal,
      isChecked: false
    }))
    return {
      ...contact,
      hasFollowUpDate: false,
      email: {
        subject: '',
        files: [],
        templateBody: '',
        template: '',
        sent: false
      },
      dealsToFollowup: dealsToFollowup,
      otherDealsToFollowUp: otherDealsToFollowUp,
      followUpDate: null,
      ccContacts: []
    }
  })
}

export const toContactEmail = contact => {
  const { dealsToFollowup, otherDealsToFollowUp, ccContacts } = contact
  const deals = dealsToFollowup.concat(otherDealsToFollowUp)
  const dealIds = deals.filter(d => d.isChecked).map(d => d.id)
  const ccUsers = ccContacts.map(c => c.value)

  const formData = new FormData()
  formData.append('contactId', contact.contactId)
  formData.append('subject', contact.email.subject)
  formData.append('emailBody', contact.email.templateBody)
  formData.append('dealIds', dealIds)
  formData.append('ccUsers', ccUsers)
  formData.append('splitMode', Object.keys(EMAIL_SPLIT_MODE)[0])

  contact.email.files.forEach(file => {
    formData.append('attachments', file)
  })

  return formData
}

export const toDealsFollowupData = contact => {
  const { dealsToFollowup, otherDealsToFollowUp, followUpDate, company } = contact
  const deals = dealsToFollowup.concat(otherDealsToFollowUp)

  const dealWithCompanies = deals
    .filter(d => d.isChecked)
    .map(d => ({ dealId: d.id, companyIds: [company.id] }))
  return {
    dealWithCompanies,
    followUpDate
  }
}

export const toUsers = users =>
  users.map(user => ({
    value: user.id,
    label: user.userName
  }))
